/**
 * PM Mini Featured Collection -- carrusel de una sola fila, scroll-snap
 * nativo + autoplay opcional. Independiente de Flickity/Multibanner:
 * ningún import, ninguna referencia cruzada.
 *
 * Idempotente: cada instancia [data-pm-mfc] se marca con
 * data-pm-mfc-bound tras inicializar, así que re-ejecuciones del script
 * (Theme Editor re-render de la sección) nunca duplican listeners.
 * Delegación de eventos en document para click de flechas -- funciona
 * igual si Shopify reemplaza el DOM de la sección completa.
 */
(function () {
  'use strict';

  if (window.pmMfcInit) return;
  window.pmMfcInit = true;

  function isMobileViewport() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function initInstance(root) {
    if (root.dataset.pmMfcBound === 'true') return;
    root.dataset.pmMfcBound = 'true';

    var track = root.querySelector('[data-pm-mfc-track]');
    var prevBtn = root.querySelector('[data-pm-mfc-prev]');
    var nextBtn = root.querySelector('[data-pm-mfc-next]');
    if (!track) return;

    var autoplayEnabled = root.dataset.autoplay === 'true';
    var intervalSeconds = parseFloat(root.dataset.autoplayInterval) || 5;
    var noAutoplayMobile = root.classList.contains('pm-mfc-wrapper--no-autoplay-mobile');
    var timer = null;
    var resumeTimeout = null;

    function slideStep() {
      var slide = track.querySelector('.pm-mfc-slide');
      if (!slide) return track.clientWidth;
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    function atEnd() {
      return track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }

    function updateArrows() {
      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 2;
      if (nextBtn) nextBtn.disabled = atEnd();
    }

    function scrollByStep(direction) {
      var step = slideStep() * direction;
      if (direction > 0 && atEnd()) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
        return;
      }
      track.scrollBy({ left: step, behavior: 'smooth' });
    }

    function shouldAutoplayNow() {
      if (!autoplayEnabled) return false;
      if (isMobileViewport() && noAutoplayMobile) return false;
      return true;
    }

    function stopAutoplay() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (!shouldAutoplayNow()) return;
      timer = window.setInterval(function () {
        if (atEnd()) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          scrollByStep(1);
        }
      }, intervalSeconds * 1000);
    }

    function pauseAndScheduleResume() {
      stopAutoplay();
      if (resumeTimeout) window.clearTimeout(resumeTimeout);
      resumeTimeout = window.setTimeout(startAutoplay, intervalSeconds * 1000);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        pauseAndScheduleResume();
        scrollByStep(-1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        pauseAndScheduleResume();
        scrollByStep(1);
      });
    }

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(updateArrows);
    }, { passive: true });

    ['pointerdown', 'touchstart', 'wheel'].forEach(function (evt) {
      track.addEventListener(evt, pauseAndScheduleResume, { passive: true });
    });

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);

    window.addEventListener('resize', function () {
      updateArrows();
    });

    updateArrows();
    startAutoplay();
  }

  function initAll() {
    document.querySelectorAll('[data-pm-mfc]').forEach(initInstance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme Editor: secciones nuevas/recargadas llegan después del load inicial.
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector && event.target.querySelector('[data-pm-mfc]');
    if (root) initInstance(root);
  });
})();
